import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Select-No",
  "use": "icon-Select-No-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Select-No\">\r\n<g id=\"icon-Select-No_&#229;&#188;&#185;&#230;&#161;&#134;/&#230;&#143;&#144;&#231;&#164;&#186;2\">\r\n<circle id=\"icon-Select-No_Ellipse 153\" cx=\"9.91016\" cy=\"9.9082\" r=\"8.25\" stroke=\"#ADADAD\" stroke-width=\"1.5\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol